import * as React from 'react';
import { Panel, Table } from 'react-bootstrap';
import { inject } from '../../../utils/decorators';
import { ApiStore } from '../../../stores/ApiStore';
import { UiStore } from '../../../stores/UiStore';
import Callout from '../../site/Callout';

import { SesStandRichtlinie, ISesNeigungenFlaeche, ISesBeurteilungsErgebnis } from '../../../models/ApiTypesSes';

interface ISesAuswertungSystemneigungProps {
  neigungenFZ: ISesNeigungenFlaeche;
  neigungenSEP: ISesNeigungenFlaeche;
  beurteilungFZ: ISesBeurteilungsErgebnis;
  beurteilungSEP: ISesBeurteilungsErgebnis;
  richtlinie: SesStandRichtlinie;
}

/** Zeigt die Systemneigungen des Gesamtsystems SES inkl. ihrer Beurteilung während der Erfassung der Messwerte an */
export default class SesAuswertungSystemneigung extends React.Component<ISesAuswertungSystemneigungProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(UiStore) uiStore: UiStore;

  render() {
    let beurteilungStyle: 'success' | 'danger' | 'warning' | 'info';
    var beurteilungText;
    let korrekturWertSEPohneNA;
    let korrekturWertSEPmitNA;
    let laengsneigungSEPio;
    let querneigungSEPio;
    let flaecheio;
    let neigungenio;
    let toleranzenio;

    let beurteilungio;

    // Korrekturwerte SEP für Ausführungen mit und ohne Niveauausgleich (NA) selektieren
    korrekturWertSEPohneNA = (this.props.neigungenFZ.laengs - this.props.neigungenSEP.quer).toLocaleString(undefined, {minimumFractionDigits: 1});
    korrekturWertSEPmitNA = this.props.neigungenFZ.laengs.toLocaleString(undefined, {minimumFractionDigits: 1});

    // Überprüfung der Gleichrichtiung der Flächen (nur für 2014er Rili)
    if (this.props.richtlinie === '2014') {
      // Korrektur nur möglich wenn Vorzeichen der Neigungen gleichgerichtet
      laengsneigungSEPio = ((this.props.neigungenFZ.laengs * this.props.neigungenSEP.quer) >= 0.0) ? true : false;
      querneigungSEPio = ((this.props.neigungenFZ.quer * this.props.neigungenSEP.laengs) >= 0.0) ? true : false;
    } else {
      laengsneigungSEPio = true;
      querneigungSEPio = true;
    }

    /*
      Beurteilung der Neigungen der Flächen zueinander

      Fläche in Ordnung wenn beide Kreuzvergleiche mit gleichem Vorzeichen
    */
    flaecheio = laengsneigungSEPio && querneigungSEPio;
    if (flaecheio) {
      beurteilungStyle = 'success';
      beurteilungText = (
        <span>
          Korrekturwert für SEP <b>ohne Niveauausgleich</b>: <b>{korrekturWertSEPohneNA}%</b><br/>
          Korrekturwert für SEP <b>mit Niveauausgleich</b>: <b>{korrekturWertSEPmitNA}%</b>
        </span>
      );
    } else {
      beurteilungStyle = 'danger';
      beurteilungText = (<span>Aufgrund der entgegengesetzten Neigungen Fahrzeug-Aufstellfläche zu SEP Aufstellfläche erfüllt diese Fläche die Anforderungen nicht.<br/><b>Eine Korrektur des SEPs ist daher nicht möglich!</b></span>);
    }

    /*
      Beurteilung der einzelnen Neigungen

      Alle Neigungen müssen im Bereich ±1,5% liegen
    */
    let maxNeigung = 1.5;
    neigungenio = (
      (Math.abs(this.props.neigungenFZ.laengs) <= maxNeigung) && (Math.abs(this.props.neigungenFZ.quer) <= maxNeigung)
      &&
      (Math.abs(this.props.neigungenSEP.laengs) <= maxNeigung) && (Math.abs(this.props.neigungenSEP.quer) <= maxNeigung)
    );
    if (flaecheio && !neigungenio) {
      beurteilungStyle = 'danger';
      beurteilungText = (<span>Aufgrund der zu großen Neigungen (außerhalb von ±1,5%) erfüllt diese Fläche die Anforderungen nicht.<br/><b>Eine Korrektur des SEPs ist daher nicht möglich!</b></span>);
    }

    /*
      Beurteilung der Toleranzen (Ebenheitsabweichungen und Unebenheiten) der beiden Flächen
    */
    const fehlerFz = this.props.beurteilungFZ.beurteilung.some(beurteilung => !beurteilung.links.eingehalten || !beurteilung.rechts.eingehalten);
    const fehlerSep = this.props.beurteilungSEP.beurteilung.some(beurteilung => !beurteilung.links.eingehalten || !beurteilung.rechts.eingehalten);
    toleranzenio = (!fehlerFz && !fehlerSep);
    if (!toleranzenio) {
      beurteilungStyle = 'danger';
      beurteilungText = (<span>Nicht alle Werte der Aufstellflächen liegen innerhalb der vorgeschriebenen Toleranzen, die Fläche erfüllt die Anforderungen nicht.<br/><b>Eine Korrektur des SEPs ist daher nicht möglich!</b></span>);
    }

    beurteilungio = flaecheio && neigungenio && toleranzenio;

    return (
      <Panel header="Systemneigung" bsStyle={beurteilungStyle}>
        <Table striped={false} bordered={true} condensed={false} hover={false} className="auswertung-systemneigung">
          <thead>
            <tr>
              <th width="20%"/>
              <th width="40%">Fahrzeug</th>
              <th width="40%">SEP</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Längs</th>
              <td className={(laengsneigungSEPio && Math.abs(this.props.neigungenFZ.laengs) <= maxNeigung) ? 'value-success' : 'value-error'}>
                {this.props.neigungenFZ.laengs.toLocaleString(undefined, {minimumFractionDigits: 1})}%
              </td>
              <td className={(querneigungSEPio && Math.abs(this.props.neigungenSEP.laengs) <= maxNeigung) ? 'value-success' : 'value-error'}>
                {this.props.neigungenSEP.laengs.toLocaleString(undefined, {minimumFractionDigits: 1})}%
              </td>
            </tr>
            <tr>
              <th>Quer</th>
              <td className={(querneigungSEPio && Math.abs(this.props.neigungenFZ.quer) <= maxNeigung) ? 'value-success' : 'value-error'}>
                {this.props.neigungenFZ.quer.toLocaleString(undefined, {minimumFractionDigits: 1})}%
              </td>
              <td className={(laengsneigungSEPio && Math.abs(this.props.neigungenSEP.quer) <= maxNeigung) ? 'value-success' : 'value-error'}>
                {this.props.neigungenSEP.quer.toLocaleString(undefined, {minimumFractionDigits: 1})}%
              </td>
            </tr>
          </tbody>
        </Table>

        <Callout bsStyle={beurteilungStyle}>
          {beurteilungText}
          {(beurteilungio) && (<div>Einzustellen an der Laser-Kalibriervorrichtung</div>)}
        </Callout>

      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/ses/SesAuswertungSystemneigung.tsx